import { createSelector, createFeatureSelector } from '@ngrx/store';
import { customerConfigState } from './reducers/customerConfig.reducer';
import { localesState, sharedLoyaltyState } from './reducers/shared.reducer';

export const loyaltySelector = createFeatureSelector('homepage');
export const customerConfig = createSelector(loyaltySelector, customerConfigState);
export const getLocalesState = createSelector((state: any) => state.shared, localesState);
export const getSharedLoyaltyState = sharedLoyaltyState; // sharedLoyaltyState is already a selector

export const loyaltyAccountSelector = createSelector(loyaltySelector, (loyalty: any) => loyalty.account);
